import React from "react";
import "./Settings.scss";

const UserManagement = ({ userListDetails }) => {
  return (
    <div>
      <div className="profile-form-container">
        <table className="table">
          <thead>
            <tr>
              <th className="settings-th" scope="col" style={{ width: "60px" }}>
                S.No
              </th>
              <th className="settings-th" scope="col">
                First Name
              </th>
              <th className="settings-th" scope="col">
                Last Name
              </th>
              <th className="settings-th" scope="col">
                Email
              </th>
              <th className="settings-th" scope="col">
                Phone
              </th>
              <th className="settings-th" scope="col">
                Designation
              </th>
              <th className="settings-th" scope="col">
                Role
              </th>
            </tr>
          </thead>
          <tbody>
            {userListDetails && userListDetails.length > 0 ? (
              userListDetails?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.first_name}</td>
                  <td>{item.last_name}</td>
                  <td>{item.user_email}</td>
                  <td>{item.phone}</td>
                  <td>{item.designation || ""}</td>
                  <td>{item.role || ""}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7}>
                  <p className="text-center">No data to show</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserManagement;
